import { createComponent } from '@carvana/merch-components';

export const HowToFindSection = createComponent('section', {
  className: `
    mx-auto
    grid
    max-w-[1056px]
    justify-items-center
    gap-4xl
    px-2xl
    py-6xl
    text-text-strong
    sm:px-3xl
    sm:py-8xl
    sm:t-heading-3xl
    md:grid-cols-[1fr_1fr]
    md:grid-rows-[auto_1fr]
    md:t-heading-2xl
  `
});

export const List = createComponent('ol', {
  className: 'grid list-none gap-2xl t-heading-lg [counter-reset:item]'
});

export const ListItem = createComponent('li', {
  className: `
    relative
    grid
    grid-cols-[auto_1fr]
    items-center
    gap-2xl
    [counter-increment:item]
    before:z-1
    before:inline-flex
    before:h-56
    before:w-56
    before:items-center
    before:justify-center
    before:rounded-full
    before:border-2
    before:bg-background-default
    before:text-text-primary
    before:content-[counter(item)]
    after:absolute
    after:-bottom-56
    after:left-28
    after:h-80
    after:border-l-2
    after:border-border-primary
    after:content-[""]
    last-of-type:after:border-0
  `
});
